import { render, staticRenderFns } from "./DeptTree.vue?vue&type=template&id=142ef153"
import script from "./DeptTree.ts?vue&type=script&lang=ts&external"
export * from "./DeptTree.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports